import { Control, Controller } from 'react-hook-form';
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import CustomButton from '../../components/Button';
import { IconButton } from '@mui/material';
import KEYS from '../../consts/consts';
import { Loader } from '../../components/Loader/Loader';
import { LoginI } from '../../utils/interface';
import LoginModuleWrapper from '../../components/LoginModuleWrapper';
import { TextInput } from '../../components/TextInput';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { pattern } from '../../utils/validationPatterns';
import styles from './Login.module.scss';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

interface LoginWrapperI {
  control: Control<LoginI>;
  isApiLoading?: boolean;
}

const LoginWrapper = ({ control, isApiLoading }: LoginWrapperI) => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  return (
    <LoginModuleWrapper>
      <div className={styles.formWrapper}>
        <p className={styles.headerText}>{KEYS.WELCOME_TO_HARSHBERGER}</p>
        <p className={styles.bodyText} style={{alignItems:'center'}}>Login to your account</p>
        <div className={styles.inputWrapper}>
          <Controller
            name='customerCode'
            control={control}
            render={({ field, fieldState: { error } }) => (
              <TextInput
                {...field}
                placeholder={"Harshberger Enterprises"}
                sx={{
                  input: {
                    padding: '16px !important',
                  },
                }}
                disabled
                error={!!error}
                helperText={error ? error.message : null}
              />
            )}
          />
          <Controller
            name='userName'
            control={control}
            rules={{
              required: KEYS.EMAIL_REQUIRED,
              validate: value => {
                if (value) {
                  if (!pattern.noSpace.test(value)) {
                    return KEYS.SPACE_NOT_ALLOWED;
                  }
                  if (!pattern.email.test(value)) {
                    return KEYS.EMAIL_INVAILD;
                  }
                }
                return undefined;
              },
            }}
            render={({ field, fieldState: { error } }) => (
              <TextInput
                {...field}
                placeholder={KEYS.ENTER_EMAILS}
                sx={{
                  input: {
                    padding: '16px !important',
                  },
                }}
                error={!!error}
                helperText={error ? error.message : null}
              />
            )}
          />
          <Controller
            name='password'
            control={control}
            rules={{ required: KEYS.PWD_REQUIRED }}
            render={({ field, fieldState: { error } }) => (
              <TextInput
                {...field}
                placeholder={KEYS.EMAIL_ENTER}
                type={showPassword ? 'text' : 'password'}
                postcontent={
                  <IconButton onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}
                  </IconButton>
                }
                sx={{
                  input: {
                    padding: '16px !important',
                  },
                }}
                error={!!error}
                helperText={error ? error.message : null}
              />
            )}
          />
        </div>
        <div className={styles.otherAction}>
          <CustomButton
            variant='text'
            sx={{ color: '#666666 !important' }}
            onClick={() => navigate('/organization')}
            disabled={isApiLoading}
          >
          
          </CustomButton>
          <CustomButton
            variant='text'
            sx={{
              color: '#666666 !important',
              textDecoration: 'underline',
            }}
            disabled={isApiLoading}
            onClick={() => navigate('/forgot-password')}
          >
            Forgot Password?
          </CustomButton>
        </div>
        <div className={styles.buttonContainer}>
          <CustomButton
            type='submit'
            sx={{
              width: '250px',
              fontSize: '14px !important',
              fontWeight: 600,
              height: '52px !important',
            }}
            disabled={isApiLoading}
          >
            Login
            {isApiLoading ? <Loader type='button' /> : <ArrowCircleRightOutlinedIcon />}
          </CustomButton>
        </div>
      </div>
    </LoginModuleWrapper>
  );
};

export default LoginWrapper;
